import { cn } from '../../lib/cn';

// Тумблер вместо галочки. Разница не косметическая: галочка отвечает на вопрос «отметить?»,
// а тумблер - на вопрос «работает?». Для настроек вида «включено/на паузе» второе понятно
// без объяснений, в том числе тому, кто видит панель первый раз.
//
// Зелёный = включено: это единственный цвет, который в таком контексте читается одинаково
// у всех. Выключенное состояние - серая дорожка границы контрола (3:1 к фону, WCAG 1.4.11).

export function Switch({
  checked,
  onChange,
  disabled,
  'aria-label': ariaLabel,
  id,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  id?: string;
}) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative h-6 w-11 shrink-0 rounded-full transition-colors',
        checked ? 'bg-green' : 'bg-line-control',
        'disabled:cursor-not-allowed disabled:opacity-50',
      )}
    >
      <span
        className={cn(
          'absolute top-0.5 left-0.5 size-5 rounded-full bg-white shadow-card transition-transform',
          checked && 'translate-x-5',
        )}
      />
    </button>
  );
}
